import React, { Component } from 'react';
import DropDownMenu from 'material-ui/DropDownMenu'
import MenuItem from 'material-ui/MenuItem';


class DropDownSelect extends Component {

  handleChange = (e, key, value) => {
    this.props.onChange(value);
  };

  render() {
    const codedValues = (this.props.codedValues) ? this.props.codedValues : [];

    let menuItems = '';
    if (this.props.useArray)
    {
      if(codedValues.length > 0) {
        menuItems = codedValues.map((item, i) => {
            return (
              <MenuItem
                key={i}
                primaryText={item}
                value={item}
              />
            )
          });
        }

    }
    else
    {
    if(codedValues.length > 0) {
      menuItems = codedValues.map((item, i) => {
          return (
            <MenuItem
              key={i}
              primaryText={item.name}
              value={item.code}
            />
          )
        });
      }
    }


      return (
        <div className="filter-item dropdown-select-filter-item">
          { (this.props.label !== '') &&
            <label>{this.props.label}</label>
          }
          <DropDownMenu
            className="selection-filter-dropdown"
            labelStyle={{color: "#fff"}}
            value={this.props.value}
            multiple={this.props.multiSelect}
            onChange={this.handleChange}>
            {menuItems}
          </DropDownMenu>
        </div>
      );
  }

}

export default DropDownSelect;
